import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  loadGenders,
  loadGendersFulfilled,
  loadGendersRejected,
  selectGenders
} from '../features/master-data.slice';
import { MasterDataService } from '../services/master-data.service';

@Injectable()
export class MasterDataEffects {
  loadGenders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadGenders),
      concatLatestFrom(() => this.store.select(selectGenders)),
      switchMap(([, genders]) =>
        (!!genders.length ? of(genders) : this.masterDataService.getGenders()).pipe(
          map((genders) => loadGendersFulfilled(genders)),
          catchError(() => of(loadGendersRejected()))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private masterDataService: MasterDataService,
    private store: Store
  ) {}
}
